import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SetMarksService from "../../services/setmarks.service";

export const getsetMarks = createAsyncThunk(
  "setmarks/getsetMarks",
  async (item, thunkAPI) => {
    try {
      const response = await SetMarksService.getSetMarks(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const setMarks = createAsyncThunk(
  "setmarks/setMarks",
  async (payload, thunkAPI) => {
    try {
      const response = await SetMarksService.setMarks(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const editSetMarks = createAsyncThunk(
  "setmarks/editSetMarks",
  async (payload, thunkAPI) => {
    try {
      const response = await SetMarksService.editSetMarks(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteSetMarks = createAsyncThunk(
  "setmarks/deleteSetMarks",
  async (id, thunkAPI) => {
    try {
      const response = await SetMarksService.deleteSetMarks(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  setmarks: [],
};

const setmarksSlice = createSlice({
  name: "setmarks",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // ================= Get Set Marks =================

      .addCase(getsetMarks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getsetMarks.fulfilled, (state, action) => {
        state.loading = false;
        state.setmarks = action.payload?.data || [];
      })
      .addCase(getsetMarks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= Add Set Marks =================

      .addCase(setMarks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(setMarks.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(setMarks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= Edit Set Marks =================

      .addCase(editSetMarks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editSetMarks.fulfilled, (state, action) => {
        state.loading = false;

        const updated = action.payload?.data;

        if (updated) {
          const index = state.setmarks.findIndex(
            (item) => item._id === updated._id
          );

          if (index !== -1) {
            state.setmarks[index] = updated;
          }
        }
      })
      .addCase(editSetMarks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ================= Delete Set Marks =================

      .addCase(deleteSetMarks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSetMarks.fulfilled, (state, action) => {
        state.loading = false;

        state.setmarks = state.setmarks.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteSetMarks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default setmarksSlice.reducer;